import o from"styled-components";import{COLORS as r}from"../../../../constants/Theme.js";const e=o.div`
	border-radius: ${o=>"2.0"===o.version?8:4}px;
	border: ${o=>"2.0"===o.version?0:1}px solid
		${r.stroke.primary};
	max-height: 480px;
	overflow: hidden;
	display: flex;
	flex-direction: row;
	position: relative;
	padding: ${o=>"2.0"===o.version?4:0}px;
	background-color: ${r.surface.standard};
`;o.div`
	padding: 14px 16px 14px 18px;
	flex-direction: row;
	align-items: center;
	border-bottom-width: 1px;
	border-bottom-style: solid;
	border-bottom-color: ${r.stroke.primary};
	width: 100%;
	height: 100%;
`;const i=o.div`
	max-height: ${o=>"number"==typeof o.maxHeight?`${o.maxHeight}px`:o.maxHeight};
	overflow-y: auto;
	position: relative;
	&::-webkit-scrollbar-thumb {
		background: #e0e0e0;
		border-radius: 8px;
	}
	&::-webkit-scrollbar {
		height: 5px;
		display: block;
		width: 8px;
	}
	&::-webkit-scrollbar-thumb:horizontal {
		width: 8px;
	}
`;export{i as MenuListContainer,e as OpennedDropdownContainer};
